"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BARE_USER_ENTRY = void 0;
exports.BARE_USER_ENTRY = {
    email: "",
    firstName: "",
    lastName: "",
    clients: [],
    isAdmin: false,
    isTrainer: false,
    uid: ""
};
//# sourceMappingURL=userModel.js.map